// extracted by mini-css-extract-plugin
export default {"chatListWrapper":"chatList_chatListWrapper__H0wva","searchWrapper":"chatList_searchWrapper__HmVb-","availableChats":"chatList_availableChats__SHUux"};